<script>
import axios from "axios";

export default {
  name: 'AuthorBlacklist',
  data() {
    return {
      pageSize: 25,
      totalPage: 1,
      current: 1,
      paginationPager: 5,
      rows: [],
      loading: false
    }
  },
  mounted() {
    this.getUserBlacklist(1)
  },
  methods: {
    async getUserBlacklist(pageNo) {
      this.loading = true
      try {
        const res = await axios.get('/api/user/author/blacklist', {
        params: {
          pageNo: pageNo,
          pageSize: this.pageSize
        },
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
        })
        if (res.data.code !== 200) throw new Error(res.data.message)
        const data = res.data.data
        this.totalPage = data.pageCount || 1
        this.current = data.current || 1
        this.rows = data.rows || []
      } catch (error) { this.$message.error(error.message || '加载黑名单失败') }
      finally { this.loading = false }
    },
    removeBlacklist(id) {
      axios.delete('/api/user/author/blacklist', {
        data: {
          id: id
        },
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
      }).then(res => {
        if (res.data.code === 200) {
          this.$notify.success({
            title: '操作成功',
            message: '移除黑名单成功'
          })
          this.getUserBlacklist(this.current)
        } else {
          this.$notify.error({
            title: '操作失败',
            message: res.data.message
          })
        }
      })
    }
  }
}
</script>

<template>
  <div class="blacklist-page" v-loading="loading">
    <p class="helper">黑名单中的社团不会出现在预告推荐中。</p>
    <el-table
        v-if="rows.length"
        class="blacklist-table"
        ref="table"
        :data="rows"
        empty-text="黑名单为空"
        size="small"
        show-header>
      <el-table-column
          prop="authorId"
          label="社团id"
          width="150"
      />
      <el-table-column
          label="社团名">
        <template slot-scope="scope">
          <div id="makerName">
            <a :href="scope.row.dlsiteUrl" target="_blank">{{ scope.row.name }}</a>
            <el-avatar :src="scope.row.avatar" style="width: 32px; height: 32px" v-if="scope.row.avatar"></el-avatar>
          </div>
        </template>
      </el-table-column>
      <el-table-column
          fixed="right"
          label="操作"
          width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="removeBlacklist(scope.row.id)">移除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="rows.length" class="blacklist-mobile">
      <el-card v-for="row in rows" :key="row.id" class="blacklist-card" shadow="never">
        <el-avatar :size="42" :src="row.avatar || undefined" icon="el-icon-user-solid"></el-avatar>
        <div class="blacklist-copy"><a v-if="row.dlsiteUrl" :href="row.dlsiteUrl" target="_blank" rel="noopener noreferrer">{{ row.name }}</a><strong v-else>{{ row.name }}</strong><span>{{ row.authorId }}</span></div>
        <el-button type="text" size="small" @click="removeBlacklist(row.id)">移除</el-button>
      </el-card>
    </div>
    <el-empty v-if="!rows.length && !loading" class="blacklist-empty" description="黑名单为空"></el-empty>
    <div v-if="totalPage > 1" class="blacklist-footer"><el-pagination background layout="prev, pager, next" :page-count="totalPage" :pager-count="paginationPager" :current-page="current" @current-change="getUserBlacklist"></el-pagination></div>
  </div>
</template>

<style scoped>
.blacklist-page { min-height: 180px; }
.helper { margin: 0 0 14px; color: #909399; font-size: 12px; }
.blacklist-table { background: transparent; }
.blacklist-table >>> th, .blacklist-table >>> tr { background: rgba(255, 255, 255, .25); }
.blacklist-table >>> td, .blacklist-table >>> th.is-leaf { border-bottom-color: rgba(220, 223, 230, .7); }
#makerName { display: flex; align-items: center; gap: 10px; }
a { color: #409eff; text-decoration: none; }
.blacklist-mobile { display: none; }
.blacklist-empty { margin-top: 35px; }
.blacklist-footer { display: flex; justify-content: flex-end; margin-top: 14px; }
@media (max-width: 767px) {
  .blacklist-table { display: none; }
  .blacklist-mobile { display: block; }
  .blacklist-card { margin-bottom: 10px; border-color: rgba(220, 223, 230, .8); border-radius: 10px; background: rgba(255, 255, 255, .48); }
  .blacklist-card >>> .el-card__body { display: flex; align-items: center; gap: 10px; padding: 10px; }
  .blacklist-copy { display: flex; flex: 1; flex-direction: column; min-width: 0; gap: 4px; font-size: 12px; }
  .blacklist-copy > a, .blacklist-copy > strong { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .blacklist-copy > span { color: #909399; font-size: 11px; }
  .blacklist-footer { justify-content: center; }
  .blacklist-footer >>> .el-pagination { padding: 0; }
}
</style>
